"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.throttle = exports._getAnchorNodeInHierarchy = exports._getSafeTimezoneOffset = exports._getSafeTimezone = exports._getSafeNetworkInformation = exports._registerEventHandler = exports._getSanitizedPageUrl = exports._getSafeUrlString = exports._getSafeUrl = exports._shouldLogEvent = exports._getTargetNode = exports._stripEmptyValues = exports.interactiveElements = void 0;
const client_core_1 = require("@statsig/client-core");
exports.interactiveElements = [
    'button',
    'a',
    'input',
    'select',
    'textarea',
    'form',
    'select',
    'label',
];
function _stripEmptyValues(obj) {
    return Object.fromEntries(Object.entries(obj).filter(([_, value]) => value != null && value !== '' && value !== undefined));
}
exports._stripEmptyValues = _stripEmptyValues;
function _getTargetNode(e) {
    if (!e) {
        return null;
    }
    let target = e.target || e.srcElement;
    if (!target || !(target instanceof Element)) {
        return null;
    }
    if (target.nodeType === 3) {
        target = (target.parentNode || null);
    }
    return target;
}
exports._getTargetNode = _getTargetNode;
function _shouldLogEvent(e, el) {
    if (!e || !el || el.nodeType !== 1) {
        return false;
    }
    const tagName = el.tagName.toLowerCase();
    const eventType = e.type.toLowerCase();
    const classList = el.classList;
    if (classList.contains('statsig-no-capture')) {
        return false;
    }
    switch (tagName) {
        case 'html':
            return false;
        case 'form':
            return eventType === 'submit';
        case 'input':
        case 'select':
        case 'textarea':
            return ['change'].includes(eventType);
        default:
            if (eventType === 'click') {
                if (tagName === 'button') {
                    return true;
                }
                const anchor = _getAnchorNodeInHierarchy(el);
                if (anchor) {
                    return true;
                }
            }
            return false;
    }
}
exports._shouldLogEvent = _shouldLogEvent;
function _getSafeUrl() {
    var _a, _b, _c;
    const href = (_c = (_b = (_a = (0, client_core_1._getWindowSafe)()) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.href) !== null && _c !== void 0 ? _c : '';
    let url;
    try {
        url = new URL(href);
    }
    catch (e) {
        url = new URL('error:');
    }
    return url;
}
exports._getSafeUrl = _getSafeUrl;
function _getSafeUrlString() {
    const urlString = _getSafeUrl().toString();
    if (urlString.startsWith('error:')) {
        return '';
    }
    return urlString;
}
exports._getSafeUrlString = _getSafeUrlString;
function _getSanitizedPageUrl() {
    return (0, client_core_1._getCurrentPageUrlSafe)() || '';
}
exports._getSanitizedPageUrl = _getSanitizedPageUrl;
function _registerEventHandler(element, eventType, handler) {
    if (!element || !element.addEventListener) {
        return;
    }
    element.addEventListener(eventType, handler, true);
}
exports._registerEventHandler = _registerEventHandler;
function _getSafeNetworkInformation() {
    const win = (0, client_core_1._getWindowSafe)();
    if (!win || !win.navigator) {
        return null;
    }
    const connection = win.navigator.connection;
    if (!connection) {
        return null;
    }
    return connection;
}
exports._getSafeNetworkInformation = _getSafeNetworkInformation;
function _getSafeTimezone() {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    }
    catch (e) {
        return null;
    }
}
exports._getSafeTimezone = _getSafeTimezone;
function _getSafeTimezoneOffset() {
    try {
        return new Date().getTimezoneOffset();
    }
    catch (e) {
        return null;
    }
}
exports._getSafeTimezoneOffset = _getSafeTimezoneOffset;
function _getAnchorNodeInHierarchy(node) {
    if (!node) {
        return null;
    }
    let parent = node;
    while (parent) {
        const parentTagName = parent.tagName.toLowerCase();
        if (['body', 'document'].includes(parentTagName)) {
            return null;
        }
        if (parent.tagName.toLowerCase() === 'a') {
            return parent;
        }
        parent = parent.parentElement;
    }
    return null;
}
exports._getAnchorNodeInHierarchy = _getAnchorNodeInHierarchy;
function throttle(fn, limit) {
    let lastCall = 0;
    return function (...args) {
        const now = Date.now();
        if (now - lastCall >= limit) {
            lastCall = now;
            fn(...args);
        }
    };
}
exports.throttle = throttle;
